
import DebugConsole from '../../utils/DebugConsole.js';

export function LogScreen() {
    return `
    <div id="log-screen" class="screen hidden" style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: #0d1117;
        color: #c9d1d9;
        font-family: 'JetBrains Mono', 'Fira Code', monospace;
        display: flex;
        flex-direction: column;
        z-index: 2000;
        padding-top: 60px; /* Header space */
    ">
        <div class="log-toolbar" style="
            display: flex; 
            padding: 10px 20px; 
            background: #161b22; 
            border-bottom: 1px solid #30363d;
            justify-content: space-between;
            align-items: center;
        ">
            <h2 style="font-size: 16px; margin: 0; color: #58a6ff;">📟 SYSTEM LOGS</h2>
            <div class="actions">
                <button onclick="window.DebugConsole.clear()" style="
                    background: #238636; 
                    border: none; 
                    color: white; 
                    padding: 5px 15px; 
                    border-radius: 4px;
                    cursor: pointer;
                    margin-right: 10px;
                ">Clear</button>
                <button onclick="window.Router.showScreen('category-screen')" style="
                    background: #da3633; 
                    border: none; 
                    color: white; 
                    padding: 5px 15px; 
                    border-radius: 4px;
                    cursor: pointer;
                ">Close</button>
            </div>
        </div>

        <div id="log-container" style="
            flex: 1;
            overflow-y: auto;
            padding: 15px;
            font-size: 13px;
        ">
            <!-- Logs will be injected here -->
        </div>

        <script>
            // Self-init logic when screen becomes active
            (function() {
                const container = document.getElementById('log-container');
                if(!container) return;

                const renderLog = (log) => {
                     if (log.type === 'clear') {
                        container.innerHTML = '';
                        return;
                    }

                    const line = document.createElement('div');
                    line.style.cssText = "margin-bottom: 5px; border-bottom: 1px solid rgba(255,255,255,0.05); padding: 2px 0;";
                    
                    let color = "#c9d1d9";
                    if (log.type === 'warn') color = "#d29922";
                    if (log.type === 'error') color = "#f85149";
                    if (log.type === 'info') color = "#58a6ff";

                    // [SECURITY FIX] Safe DOM Manipulation
                    const timeSpan = document.createElement('span');
                    timeSpan.style.color = "#8b949e";
                    timeSpan.style.marginRight = "5px";
                    timeSpan.textContent = log.timestamp;

                    const typeSpan = document.createElement('strong');
                    typeSpan.style.color = color;
                    typeSpan.style.textTransform = "uppercase";
                    typeSpan.style.margin = "0 5px";
                    typeSpan.textContent = "[" + log.type + "]";

                    const msgSpan = document.createElement('span');
                    msgSpan.style.color = "#e6edf3";
                    msgSpan.textContent = log.message;

                    line.appendChild(timeSpan);
                    line.appendChild(typeSpan);
                    line.appendChild(msgSpan);
                    
                    container.appendChild(line);
                    container.scrollTop = container.scrollHeight;
                };

                // Subscribe
                if(window.DebugConsole) {
                    window.DebugConsole.subscribe(renderLog);
                }
            })();
        </script>
    </div>
    `;
}

// Global script to handle cleanup/subscription properly (since inner script runs only once on render)
window.initLogScreen = function () {
    const container = document.getElementById('log-container');
    if (!container) return;

    // Remove old logs to prevent Duplication on re-visit
    container.innerHTML = '';

    const renderLog = (log) => {
        if (log.type === 'clear') {
            container.innerHTML = '';
            return;
        }

        const line = document.createElement('div');
        line.style.cssText = "margin-bottom: 2px; font-family: 'Consolas', monospace; border-bottom: 1px solid #21262d; padding: 4px; white-space: pre-wrap; word-break: break-all;";

        let color = "#e6edf3";
        let bg = "";

        if (log.type === 'warn') { color = "#d29922"; bg = "rgba(210, 153, 34, 0.1)"; }
        if (log.type === 'error') { color = "#ff7b72"; bg = "rgba(248, 81, 73, 0.1)"; }
        if (log.type === 'info') { color = "#58a6ff"; }

        line.style.backgroundColor = bg;

        // [SECURITY FIX] Safe DOM Creation to prevent XSS
        const timeSpan = document.createElement('span');
        timeSpan.style.color = "#8b949e";
        timeSpan.style.marginRight = "8px";
        timeSpan.textContent = log.timestamp;

        const msgSpan = document.createElement('span');
        msgSpan.style.color = color;
        msgSpan.textContent = log.message; // Safe text insertion

        line.appendChild(timeSpan);
        line.appendChild(msgSpan);

        container.appendChild(line);
        // Auto-scroll only if at bottom
        container.scrollTop = container.scrollHeight;
    };

    if (window.DebugConsole) {
        // Unsubscribe old listener if any (simplistic approach: clear all listeners for this specific task?)
        // Better: DebugConsole.subscribe returns an unsubscribe function or we manage it here.
        // For now, simple Subscribe is okay as long as we clear innerHTML.
        // ACTUALLY: DebugConsole.subscribe sends ALL history. So clearing innerHTML is correct.

        // We need to store the listener to unsubscribe later? 
        // For this simple implementation, we'll just subscribe. Warning: Multiple subscriptions if init called multiple times?
        // Let's implement a singleton check in DebugConsole or clear listeners?

        // Let's rely on Screen activation logic in Router to call this?
        // Or better, let's make initLogScreen idempotent.
        if (window._logListener) {
            window.DebugConsole.unsubscribe(window._logListener);
        }

        window._logListener = renderLog;
        window.DebugConsole.subscribe(renderLog);
    }
}
